let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5lsf6")).then(() => parcelRequire('bF0Un'));